import "./styles/main.css";
import { currentClientData } from "./config/current-client";
import { validateClientConfig } from "./config/validate-client";
import { LuckyWheel } from "./components/lucky-wheel";

const app = document.querySelector<HTMLElement>("#app");

if (!app) {
  throw new Error("Application root was not found.");
}

try {
  const clientConfig = validateClientConfig(currentClientData);
  new LuckyWheel(clientConfig, app);
} catch (error) {
  const message = error instanceof Error ? error.message : "Unknown configuration error.";
  console.error("Lucky Spin could not start:", error);
  app.innerHTML = `
    <main class="configuration-error">
      <p>Configuration error</p>
      <h1>This campaign is temporarily unavailable.</h1>
      <code>${message}</code>
    </main>
  `;
}
